var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMultipleUser = function SvgMultipleUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "multiple-user_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#multiple-user_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18v-1.575c0-.733.367-1.321 1.1-1.763C1.833 14.221 2.8 14 4 14c.217 0 .421.008.613.025.191.017.379.042.562.075a3.553 3.553 0 0 0-.513 1.075A4.499 4.499 0 0 0 4.5 16.4V18H0Zm6 0v-1.6c0-1.083.554-1.963 1.663-2.638 1.108-.675 2.554-1.012 4.337-1.012 1.8 0 3.25.337 4.35 1.012 1.1.675 1.65 1.555 1.65 2.638V18H6Zm13.5 0v-1.6c0-.433-.058-.842-.175-1.225a4.213 4.213 0 0 0-.5-1.075c.183-.033.371-.058.563-.075.191-.017.395-.025.612-.025 1.2 0 2.167.22 2.9.662.733.442 1.1 1.03 1.1 1.763V18h-4.5ZM4 13c-.55 0-1.02-.196-1.412-.588A1.923 1.923 0 0 1 2 11c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 4 9c.55 0 1.02.196 1.412.587C5.804 9.979 6 10.45 6 11s-.196 1.02-.588 1.412A1.923 1.923 0 0 1 4 13Zm16 0c-.55 0-1.021-.196-1.413-.588A1.925 1.925 0 0 1 18 11c0-.55.196-1.021.587-1.413A1.928 1.928 0 0 1 20 9c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.412A1.927 1.927 0 0 1 20 13Zm-8-1a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 9 9c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 12 6c.833 0 1.542.292 2.125.875S15 8.167 15 9s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 12 12Z",
    fill: "#6E7179"
  }))));
};
export default SvgMultipleUser;